var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMember({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_add_new_member",
    "data-name": "icon add new member",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "User_Add",
    "data-name": "User Add",
    d: "M9,7.967A2.234,2.234,0,1,0,6.731,5.733,2.251,2.251,0,0,0,9,7.967Zm0,1.5A3.734,3.734,0,1,0,5.231,5.733,3.751,3.751,0,0,0,9,9.467Zm1.27,2.567H7.463A4.081,4.081,0,0,0,3.5,16.222a.311.311,0,0,0,.082.218.17.17,0,0,0,.125.06H10.35a.758.758,0,0,1,0,1.5H3.707A1.744,1.744,0,0,1,2,16.222a5.58,5.58,0,0,1,5.463-5.689H10.27A.741.741,0,0,1,11,11.3.729.729,0,0,1,10.27,12.033Zm5.23-.283a.75.75,0,0,0-1.5,0V13.5H12.25a.75.75,0,0,0,0,1.5H14v1.75a.75.75,0,1,0,1.5,0V15h1.75a.75.75,0,0,0,0-1.5H15.5Z",
    transform: "translate(-2 -2)",
    fill: "#333",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMember);
export default __webpack_public_path__ + "static/media/add-member.30396a50c538466ff8f9e4a55cd5dbca.svg";
export { ForwardRef as ReactComponent };